// @flow
import React from 'react';
import { connect } from 'react-redux';
import { userControlTokenSelector, emailSelector } from '../Authentication/selectors';
import { notificationsManagerUrlSelector } from './selectors';
import LinkProgressive from './components/LinkProgressive/component';
import LinkLegacy from './components/LinkLegacy/component';

type MapStateToProps = {
  userControlToken: ?string,
  email: ?string,
  legacyManagerUrl: ?string,
};

type Props = MapStateToProps;

export function CallToActionLinkContainer({ userControlToken, email, legacyManagerUrl }: Props) {
  if (userControlToken && email) {
    return <LinkProgressive userControlToken={userControlToken} email={email} />;
  }

  if (legacyManagerUrl) {
    return <LinkLegacy url={legacyManagerUrl} />;
  }

  return null;
}

export function mapStateToProps(state: Object): MapStateToProps {
  return {
    userControlToken: userControlTokenSelector(state),
    email: emailSelector(state),
    legacyManagerUrl: notificationsManagerUrlSelector(state),
  };
}

export default connect(mapStateToProps)(CallToActionLinkContainer);



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/CallToActionLink/container.js